module.exports = __webpack_public_path__ + "media/voiceover.5b7df22e.mp3";